export default __webpack_public_path__ + "static/media/LaidojimoReikmenys.184a4312.svg";